<template>
  <el-result :style="isLoading? 'display: none' : ''" subTitle="您访问的资源不存在！" style="margin-top: 10%;">
    <template slot="icon">
      <el-image src="image/error.png" style="width: 50%;"></el-image>
    </template>
  </el-result>
</template>
<script>
export default {
  name: 'Error',
  data() {
    return {
      isLoading: true
    }
  },
  mounted() {
    if(!this.isLoading){
      document.title = '404';
    }
  }
}
</script>